var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePageContainer',{staticClass:"pt-10"},[_c('PageHeader',{attrs:{"has-back":"","with-members":""}},[_vm._v(" 前所属・経歴 ")]),(_vm.initialized)?_c('PastDepartmentsForm',{ref:"form",attrs:{"past-departments":_vm.pastDepartments,"api-errors":_vm.apiErrors},on:{"submit":_vm.postPastDepartments}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }